import { Col, Tag, Typography } from 'antd';
import { confirmation, ProjectsConstructorCard } from '@/components';
import { ColumnForm } from './ColumnForm';
import { AddColumnDto, ProjectDto, ColumnTypesEnum } from '@/core';
import { useDeleteColumnMutation, useUpdateColumnMutation } from '@/redux';
import { getColumnSettings } from '@/pages/Projects.Constructor';
import { useTagColor } from './hooks/useTagColor';
import { useTranslation } from 'react-i18next';
import classes from './ColumnCard.module.scss';

type PropsType = {
  onClickMenuEdit: () => void;
  isEdit: boolean;
  stopEditCard: (id: string) => void;
  sourceName: string;
  name: string;
  type: ColumnTypesEnum;
  id: string;
  projectData: ProjectDto;
  isCardUnremovable?: boolean;
};

export const ColumnCard = ({
  sourceName,
  name,
  type,
  isEdit,
  id,
  onClickMenuEdit,
  stopEditCard,
  projectData,
  isCardUnremovable,
}: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const tagColor = useTagColor(type);
  const [updateColumn] = useUpdateColumnMutation();
  const [deleteColumn] = useDeleteColumnMutation();
  const affectedByColumnTables = projectData.tables.filter((table) =>
    table.columns.some(({ columnId }) => columnId === id),
  );

  const submitUpdateColumn = (columnData: AddColumnDto) => {
    updateColumn({ columnData: { ...columnData, type }, id })
      .unwrap()
      .then(() => stopEditCard(id));
  };
  const onClickMenuDelete = () =>
    confirmation.show({
      title: t('addColumns.delete.title'),
      body: t('addColumns.delete.body', { affectedTablesQuantity: affectedByColumnTables.length }),
      isConfirmButtonDanger: true,
      onConfirm: () => deleteColumn({ id }),
      confirm: 'Delete',
    });

  return (
    <ProjectsConstructorCard
      isEdit={isEdit}
      onClickMenuDelete={onClickMenuDelete}
      onClickMenuEdit={onClickMenuEdit}
      isCardUnremovable={isCardUnremovable}
      editForm={
        <ColumnForm
          handleCancel={() => stopEditCard(id)}
          handleSubmit={submitUpdateColumn}
          initialValue={{ sourceName, name }}
          formUid={name}
          isCancelButton
          columnType={type}
          projectData={projectData}
        />
      }
    >
      <Col xs={6} md={4}>
        <div className={classes.tagsWrapper}>
          <Tag color={tagColor}>
            <Typography.Text ellipsis>{getColumnSettings(type).label}</Typography.Text>
          </Tag>
        </div>
      </Col>
      <Col xs={9} md={10}>
        <Typography.Paragraph className="pe-3">{sourceName}</Typography.Paragraph>
      </Col>
      <Col xs={9} md={10}>
        <Typography.Paragraph className="pe-3">{name}</Typography.Paragraph>
      </Col>
    </ProjectsConstructorCard>
  );
};
